import React, { useEffect, useState } from 'react';
import DockVerticalDerecha from '../estructura/DockVerticalDerecha';
import { toast } from 'react-toastify';
import instanciaAxios, { esErrorPermiso } from '../../miscelaneo/instanciaAxios';
import PlantillaModal from '../util/PlantillaModal';
import InputCatalogoCuentas from '../util/Inputs/InputCatalogoCuentas';
import ModalSeleccionCuenta from '../util/ModalSeleccionCuenta';
import FuncionesGenerales from '../util/FuncionesGenerales';
import TablaCuentaTesoreria from '../util/tablas/TablaCuentaTesoreria';
import SpinnerCargando from '../util/SpinnerCargando';

function MantenimientoCuentatesoreria() {
    const [formData, setFormData] = useState({});
    const [estados, setEstados] = useState([]);
    const [cargando, setCargando] = useState(true);
    // Deshabilita el botón "Guardar" mientras se espera la respuesta del backend
    // (evita que un doble clic duplique la cuenta de tesorería).
    const [guardandoCuenta, setGuardandoCuenta] = useState(false);
    const [modo, setModo] = useState('creacion');
    const [editable, setEditable] = useState(true);
    const { obtenerFechaActual, formatearFechaInput, formatoMoneda } = FuncionesGenerales();
    const [cuentaSeleccionada, setCuentaSeleccionada] = useState(null);
    const [mostrarModalCuenta, setMostrarModalCuenta] = useState(false);
    const [mostrarModalCuentaTesoreria, setMostrarModalCuentaTesoreria] = useState(false);
    const [monedas, setMonedas] = useState([]);
    const [bancos, setBancos] = useState([]);
    const [tiposCuentas, setTiposCuentas] = useState([]);
    const [modoBanco, setModoBanco] = useState(false);
    const [nombresCuentas, setNombresCuentas] = useState({});
    const [campoCuentaActivo, setCampoCuentaActivo] = useState(null);


    const abrirModalCuenta = (campoId) => {
        setCampoCuentaActivo(campoId);
        setMostrarModalCuenta(true);
    };

    const handleChange = (e) => {
        const { id, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: type === 'checkbox' ? checked : value,
        }));
    };

    const obtenerSimboloMoneda = (id_moneda) => {
    const moneda = monedas.find(m => m.id_moneda === id_moneda);
    return moneda?.simbolo || '';
};

    const handleSeleccionCuenta = (cuenta) => {
        const campoId = campoCuentaActivo;
        setFormData((prev) => ({
            ...prev,
            [campoId]: cuenta[0],
        }));
        setNombresCuentas((prev) => {
            const nuevo = { ...prev, [campoId]: cuenta[1] };
            return nuevo;
        });
        setCuentaSeleccionada(cuenta);
        setMostrarModalCuenta(false);
    };

    useEffect(() => {
        setEditable(modo !== 'ver');
        setCuentaSeleccionada(null);
        const mensajes = {
            'ver': 'Modo solo observación',
            'edicion': 'Modo edición',
            'creacion': 'Modo creación'
        };
        toast.info(mensajes[modo]);
    }, [modo]);

    useEffect(() => {
        if (formData?.id_tipo_cuenta_tesoreria != 1) {
            setModoBanco(true);
            // Solo cuentas de tipo Efectivo pueden ser caja
            setFormData((prev) => ({
                ...prev,
                permite_sesion_caja: false
            }));
        } else {
            setModoBanco(false);
            setFormData((prev) => ({
                ...prev,
                id_banco: null,
                numero_cuenta: null
            }));
        }
    }, [formData?.id_tipo_cuenta_tesoreria]);

    useEffect(() => {
        // If "usar como caja" is checked, force tipo to be Efectivo (1)
        if (formData?.permite_sesion_caja && formData?.id_tipo_cuenta_tesoreria != 1) {
            setFormData((prev) => ({
                ...prev,
                id_tipo_cuenta_tesoreria: 1
            }));
        }
    }, [formData?.permite_sesion_caja]);

    useEffect(() => {
        const fetchDatos = async () => {
            setCargando(true);
            try {
                const [Estados, Monedas, Bancos, TiposCuentas] = await Promise.all([
                    instanciaAxios.get('/miscelaneo/estado'),
                    instanciaAxios.get('/miscelaneo/moneda'),
                    instanciaAxios.get('/banco'),
                    instanciaAxios.get('/cuenta_tesoreria/tipo_cuenta_tesoreria'),
                ]);
                setEstados(Estados.data);
                setMonedas(Monedas.data);
                setBancos(Bancos.data);
                setTiposCuentas(TiposCuentas.data);
            } catch (error) {
                if (esErrorPermiso(error)) return;
                console.error('Error al cargar datos:', error);
                toast.error('Error al cargar los datos');
            } finally {
                setCargando(false);
            }
        };
        setFormData((prev) => ({
            ...prev,
            fecha_creacion: obtenerFechaActual(),
            // id_cuenta_contable: '',
        }))
        fetchDatos();
    }, []);

    const campos = [
        //  {
        //     id: "id_cuenta_contable",
        //     label: "*Cuenta contable",
        //     seccion: "Contabilidad",
        //     custom: (valorActual, onClickAbrirModal) => (
        //         <InputCatalogoCuentas
        //             valor={valorActual}
        //             onClick={onClickAbrirModal}
        //             nombreCuenta={nombresCuentas["id_cuenta_contable"]}
        //             placeholder="Seleccionar cuenta contable"
        //         />
        //     )
        // },
        {
            id: "descripcion",
            type: "text",
            label: "Descripción",
            placeholder: "Descripción",
            seccion: "Información de cuenta tesoreria",
            required: true
        },
        {
            id: "id_tipo_cuenta_tesoreria",
            type: "select",
            label: "Tipo de cuenta",
            placeholder: "Tipo de cuenta",
            seccion: "Información de cuenta tesoreria",
            required: true,
            opciones: tiposCuentas.map(tipo => ({
                label: tipo.descripcion,
                value: tipo.id_tipo_cuenta_tesoreria
            }))
        },
        {
            id: "numero_cuenta",
            type: "text",
            label: "Número de cuenta",
            placeholder: "Número de cuenta",
            seccion: "Información de cuenta tesoreria",
            required: true
        },
        {
            id: "saldo",
            type: "text",
            label: "Saldo actual",
            placeholder: "Saldo actual",
            seccion: "Información de cuenta tesoreria"
        },
        {
            id: "fecha_creacion",
            type: "date",
            label: "Fecha de Creación",
            placeholder: "Fecha de creación",
            seccion: "Información de cuenta tesoreria",
            required: true
        },
        {
            id: "id_moneda",
            type: "select",
            label: "Moneda",
            placeholder: "Moneda",
            seccion: "Información de cuenta tesoreria",
            required: true,
            opciones: monedas.map(moneda => ({
                label: moneda.descripcion,
                value: moneda.id_moneda
            }))
        },
        {
            id: "id_banco",
            type: "select",
            label: "Banco",
            placeholder: "Banco",
            seccion: "Información de cuenta tesoreria",
            required: true,
            opciones: bancos.map(banco => ({
                label: banco.descripcion,
                value: banco.id_banco
            }))
        },
        {
            id: "id_estado",
            label: "Estado",
            placeholder: "Estado",
            type: "select",
            opciones: estados.map(estado => ({
                label: estado.descripcion,
                value: estado.id_estado
            })),
            seccion: "Información de cuenta tesoreria"
        },
        {
            id: "permite_sesion_caja",
            type: "checkbox",
            label: "Usar como caja registradora",
            seccion: "Información de cuenta tesoreria",
        },
        {
            id: "ultima_conciliacion",
            type: "date",
            label: "Última conciliación",
            placeholder: "Última conciliación",
            seccion: "Conciliación",
        },
        {
            id: "saldo_ultima_conciliacion",
            type: "text",
            label: "Saldo de la última conciliación",
            placeholder: "Saldo de la última conciliación",
            seccion: "Conciliación",
        },
        {
            id: "comentario",
            type: "textarea",
            label: "Comentario",
            placeholder: "Comentario",
            seccion: "Comentario acerca de la cuenta"
        }
    ];

    const camposPorSeccion = campos.reduce((acc, campo) => {
        if (!acc[campo.seccion]) acc[campo.seccion] = [];
        acc[campo.seccion].push(campo);
        return acc;
    }, {});

    async function SubmitCuentatesoreria() {
        if (guardandoCuenta) return;
        console.log('SubmitCuentatesoreria', formData);
        const errores = [
            { cond: !formData.fecha_creacion, msg: 'La fecha de creación de la cuenta es obligatoria' },
            { cond: !formData.id_tipo_cuenta_tesoreria, msg: 'El tipo de cuenta es obligatorio' },
            { cond: !formData.descripcion, msg: 'La descripción de la cuenta es obligatoria' },
            { cond: !formData.id_moneda, msg: 'La moneda de la cuenta es obligatoria' },
            { cond: !formData.id_estado, msg: 'El estado de la cuenta es obligatorio' }
        ];
        for (let error of errores) {
            if (error.cond) {
                toast.error(error.msg);
                return;
            }
        }
        try {
            let id_cuenta_tesoreria = formData.id_cuenta_tesoreria;
            console.log('id_cuenta_tesoreria', id_cuenta_tesoreria);
            const payload = { ...formData };
            if (modo === 'ver') {
                toast.info('Modo solo observación. No se puede guardar.');
                return;
            }
            setGuardandoCuenta(true);
            if (modo === 'creacion') {
                const res = await instanciaAxios.post('/cuenta_tesoreria', payload);
                id_cuenta_tesoreria = res.data.id_cuenta_tesoreria;
                setFormData(prev => ({
                    ...prev,
                    id_cuenta_tesoreria: id_cuenta_tesoreria,
                }));
                toast.success('Cuenta tesoreria registrada con éxito');
            }
            if (modo === 'edicion') {
                await instanciaAxios.put('/cuenta_tesoreria', payload);
                toast.success('Cuenta tesoreria editada con éxito');
            }
            setModo('ver');
        } catch (error) {
            if (esErrorPermiso(error)) return;
            toast.error('Error al guardar la cuenta tesoreria');
            console.error(error);
        } finally {
            setGuardandoCuenta(false);
        }
    }

    async function handleBotonCrear() {
        try {
            setModo('creacion');
            setFormData({
                descripcion: '',
                id_tipo_cuenta_tesoreria: '',
                numero_cuenta: '',
                saldo: '',
                fecha_creacion: formatearFechaInput(obtenerFechaActual()),
                id_moneda: '',
                id_banco: '',
                // id_cuenta_contable: '',
                ultima_conciliacion: '',
                saldo_ultima_conciliacion: '',
                id_estado: estados.length > 0 ? estados[0].id_estado : '',
                comentario: '',
                permite_sesion_caja: false,
                nombre_impresora_termica: ''
            });
            setNombresCuentas((prev) => ({
                ...prev,
                id_cuenta_contable: '',
            }))
        } catch (error) {
            console.error('Error al inicializar el formulario de creación:', error);
        }
    }

    async function handleBotonBuscar() {
        try {
            setMostrarModalCuentaTesoreria(true)
            setModo('ver');
        } catch (error) {
            console.log(error);
        }
    }

    async function handleBotonEditar() {
        try {
            setMostrarModalCuentaTesoreria(true)
            setModo('edicion');
        } catch (error) {
            console.log(error);
        }
    }

    async function handleSeleccionarCuentaTesoreria(id_cuenta_tesoreria) {
        console.log('handleSeleccionarCuentaTesoreria', id_cuenta_tesoreria);
        setMostrarModalCuentaTesoreria(false);
        try {
            const respuesta = await instanciaAxios.get('/cuenta_tesoreria/' + id_cuenta_tesoreria);
            const data = respuesta.data;
            console.log('Datos de la cuenta seleccionada:', data);

            setFormData((prevData) => ({
                ...prevData,
                id_cuenta_tesoreria: data.id_cuenta_tesoreria || '',
                descripcion: data.descripcion || '',
                id_tipo_cuenta_tesoreria: data.id_tipo_cuenta_tesoreria || '',
                numero_cuenta: data.numero_cuenta || '',
                saldo: formatoMoneda(data.saldo, obtenerSimboloMoneda(data.id_moneda)) || '',
                fecha_creacion: data.fecha_creacion ? formatearFechaInput(data.fecha_creacion) : formatearFechaInput(obtenerFechaActual()),
                id_moneda: data.id_moneda || '',
                id_banco: data.id_banco || '',
                // id_cuenta_contable: data.id_cuenta_contable || '',
                ultima_conciliacion: data.ultima_conciliacion ? formatearFechaInput(data.ultima_conciliacion) : '',
                saldo_ultima_conciliacion: formatoMoneda(data.saldo_ultima_conciliacion, obtenerSimboloMoneda(data.id_moneda)) || '',
                id_estado: data.id_estado || (estados.length > 0 ? estados[0].id_estado : ''),
                comentario: data.comentario || '',
                permite_sesion_caja: !!data.permite_sesion_caja,
                nombre_impresora_termica: data.nombre_impresora_termica || '',
            }));
            console.log('saldo ultima conciliacion', data.saldo_ultima_conciliacion);
            setNombresCuentas((prev) => ({
                ...prev,
                id_cuenta_contable: data.cuenta_contable
            }))
        } catch (error) {
            console.error('Error al obtener cuenta de tesorería:', error);
        }
    }

    return (
        cargando ? (
            <SpinnerCargando />
        ) : (
            <div className="bg-gray-200 min-h-screen">
                <div className="flex justify-center py-10">
                    <div className="bg-gray-100 bg-opacity-90 rounded-xl border border-gray-100 p-12 w-full max-w-7xl mx-10">
                        <form className="flex flex-col gap-8">
                            <div className="space-y-1">
                                <h1 className="font-cascadia font-bold text-2xl">Cuenta tesoreria</h1>
                                <p className="text-gray-500">Complete los campos y administre la información de cada cuenta tesoreria.</p>
                            </div>
                            {Object.entries(camposPorSeccion).map(([titulo, campos]) => (
                                <div key={titulo}>
                                    <h2 className="text-lg font-semibold mb-4">{titulo}</h2>
                                    <div className="grid gap-4 grid-cols-[repeat(auto-fit,_minmax(240px,_1fr))]">
                                        {campos.map((campo) => (
                                            <div key={campo.id} className="flex flex-col">
                                                <label htmlFor={campo.id} className="text-sm font-medium text-gray-600 mb-1 flex items-center gap-1">
                                                    {campo.label}
                                                    {campo.required && <span className="text-red-500">*</span>}
                                                </label>
                                                {campo.custom ? (
                                                    campo.custom(
                                                        formData[campo.id],
                                                        editable ? () => abrirModalCuenta(campo.id) : () => { }
                                                    )
                                                ) : campo.type === "checkbox" ? (
                                                    <label className="flex items-center gap-3 mt-1 cursor-pointer select-none">
                                                        <input
                                                            type="checkbox"
                                                            id={campo.id}
                                                            checked={!!formData[campo.id]}
                                                            onChange={handleChange}
                                                            disabled={!editable || (campo.id === "permite_sesion_caja" && formData?.id_tipo_cuenta_tesoreria != 1)}
                                                            className="w-5 h-5 rounded border-2 border-gray-300 text-color-principal focus:ring-color-principal cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                                                        />
                                                        <span className={`text-sm ${(!editable || (campo.id === "permite_sesion_caja" && formData?.id_tipo_cuenta_tesoreria != 1)) ? 'text-gray-400' : 'text-gray-700'}`}>
                                                            {formData?.permite_sesion_caja
                                                                ? 'Esta cuenta se usará para sesiones de caja (solo tipo Efectivo)'
                                                                : formData?.id_tipo_cuenta_tesoreria == 1
                                                                    ? 'Esta cuenta se usará para sesiones de caja'
                                                                    : 'Solo disponible para cuentas de tipo Efectivo'}
                                                        </span>
                                                    </label>
                                                ) : campo.type === "select" ? (
                                                    <select
                                                        id={campo.id}
                                                        value={formData[campo.id] || ""}
                                                        onChange={handleChange}
                                                        disabled={
                                                            !editable ||
                                                            ((campo.id === "numero_cuenta" || campo.id === "id_banco") && !modoBanco) ||
                                                            (campo.id === "id_tipo_cuenta_tesoreria" && formData?.permite_sesion_caja)
                                                        }
                                                        className={`w-full p-2 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                                            campo.required && editable
                                                                ? "border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100"
                                                                : "border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                                                        }`}
                                                    >
                                                        <option value="">Seleccione una opción</option>
                                                        {campo.opciones?.map((option) => (
                                                            <option key={option.value} value={option.value}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                ) : campo.type === "textarea" ? (
                                                    <textarea
                                                        id={campo.id}
                                                        value={formData[campo.id] || ""}
                                                        onChange={handleChange}
                                                        placeholder={campo.placeholder}
                                                        disabled={!editable}
                                                        className={`w-full p-2 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                                            campo.required && editable
                                                                ? "border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100"
                                                                : "border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                                                        }`}
                                                    />
                                                ) : (
                                                    <input
                                                        type={campo.type}
                                                        id={campo.id}
                                                        value={formData[campo.id] || ""}
                                                        onChange={handleChange}
                                                        placeholder={campo.placeholder}
                                                        disabled={
                                                            !editable || campo.id === "saldo" || campo.id === "saldo_ultima_conciliacion" || campo.id === "fecha_creacion" ||
                                                            ((campo.id === "numero_cuenta" || campo.id === "id_banco") && !modoBanco)
                                                        }
                                                        className={`w-full p-2 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                                            campo.required && editable
                                                                ? "border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100"
                                                                : "border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                                                        }`}
                                                    />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}

                            {/* Printer config hint — visible when permite_sesion_caja is checked */}
                            {formData?.permite_sesion_caja && (
                                <div className="border-t pt-6">
                                    <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 flex items-start gap-3">
                                        <span className="text-blue-500 text-xl mt-0.5">🖨️</span>
                                        <div>
                                            <p className="text-sm font-medium text-blue-800">
                                                Configuración de impresora térmica
                                            </p>
                                            <p className="text-sm text-blue-600 mt-1">
                                                La impresora y el tamaño de papel para esta caja se configuran desde el módulo
                                                {' '}<a href="/ConfiguracionImpresion" className="underline font-semibold hover:text-blue-800">
                                                    Caja → Configuración de Impresión
                                                </a>.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </form>
                        <DockVerticalDerecha
                            handleBotonGuardar={(e) => SubmitCuentatesoreria(e)}
                            handleBotonCrear={() => handleBotonCrear()}
                            handleBotonBuscar={() => handleBotonBuscar()}
                            handleBotonEditar={() => handleBotonEditar()}
                            guardando={guardandoCuenta}
                        />

                        <ModalSeleccionCuenta
                            mostrar={mostrarModalCuenta}
                            onClose={() => setMostrarModalCuenta(false)}
                            handleSeleccionCuenta={handleSeleccionCuenta}
                            descripcion="Seleccione la cuenta para asignar"
                        />
                        <PlantillaModal
                            mostrar={mostrarModalCuentaTesoreria}
                            onClose={() => setMostrarModalCuentaTesoreria(false)}
                        >
                            <TablaCuentaTesoreria
                                setCuentaSeleccionada={handleSeleccionarCuentaTesoreria}
                            />
                        </PlantillaModal>
                    </div>
                </div>
            </div>
        )
    );
}

export default MantenimientoCuentatesoreria;
